import {
    AllocationUsageType,
    ExternalEventAllocationUsageType,
    ExternalEventSeriesCategory,
    ProjectAllocationUsageType,
} from '@/generated/graphql';
import { PhaseColor, PhaseTypeDatabase } from './Timeline.types';

const nonExternalEventColorMap: Record<Exclude<PhaseTypeDatabase, ExternalEventAllocationUsageType>, PhaseColor> = {
    [AllocationUsageType.TechnicalSetUp]: 'Technical-Set-Up',
    [AllocationUsageType.TechnicalBreakdown]: 'Technical-Breakdown',
    [AllocationUsageType.ExtendedTechnicalSetUp]: 'Extended-Technical-Set-Up',
    [AllocationUsageType.ExtendedTechnicalBreakdown]: 'Extended-Technical-Breakdown',
    [AllocationUsageType.EarlySetUp]: 'Early-Set-Up',
    [AllocationUsageType.ExtendedBreakdown]: 'Extended-Breakdown',
    [AllocationUsageType.RegularSetUp]: 'Regular-Set-Up',
    [AllocationUsageType.RegularBreakdown]: 'Regular-Breakdown',
    [AllocationUsageType.ShowDays]: 'Event',
    [ProjectAllocationUsageType.Project]: 'Project',
    [ProjectAllocationUsageType.ProjectSetUp]: 'Project-Set-Up',
    [ProjectAllocationUsageType.ProjectBreakdown]: 'Project-Breakdown',
    Aggregation: 'Aggregation',
};

const externalEventColorMap: Record<
    ExternalEventAllocationUsageType,
    Record<ExternalEventSeriesCategory, PhaseColor>
> = {
    [ExternalEventAllocationUsageType.PreExternalEvent]: {
        [ExternalEventSeriesCategory.Holiday]: 'Pre-External-Event-Category-External-Event',
        [ExternalEventSeriesCategory.Other]: 'Pre-External-Event-Category-External-Event',
        [ExternalEventSeriesCategory.Politics]: 'Pre-External-Event-Category-External-Event',
        [ExternalEventSeriesCategory.PublicHoliday]: 'Pre-External-Event-Category-External-Event',
        [ExternalEventSeriesCategory.Social]: 'Pre-External-Event-Category-External-Event',
        [ExternalEventSeriesCategory.Sport]: 'Pre-External-Event-Category-External-Event',
        [ExternalEventSeriesCategory.Competition]: 'Pre-External-Event-Category-Event',
        [ExternalEventSeriesCategory.World]: 'Pre-External-Event-Category-Event',
        [ExternalEventSeriesCategory.ExternalConstruction]: 'Pre-External-Event-Category-Project',
    },
    [ExternalEventAllocationUsageType.ExternalEvent]: {
        [ExternalEventSeriesCategory.Holiday]: 'External-Event-Category-External-Event',
        [ExternalEventSeriesCategory.Other]: 'External-Event-Category-External-Event',
        [ExternalEventSeriesCategory.Politics]: 'External-Event-Category-External-Event',
        [ExternalEventSeriesCategory.PublicHoliday]: 'External-Event-Category-External-Event',
        [ExternalEventSeriesCategory.Social]: 'External-Event-Category-External-Event',
        [ExternalEventSeriesCategory.Sport]: 'External-Event-Category-External-Event',
        [ExternalEventSeriesCategory.Competition]: 'External-Event-Category-Event',
        [ExternalEventSeriesCategory.World]: 'External-Event-Category-Event',
        [ExternalEventSeriesCategory.ExternalConstruction]: 'External-Event-Category-Project',
    },
    [ExternalEventAllocationUsageType.PostExternalEvent]: {
        [ExternalEventSeriesCategory.Holiday]: 'Post-External-Event-Category-External-Event',
        [ExternalEventSeriesCategory.Other]: 'Post-External-Event-Category-External-Event',
        [ExternalEventSeriesCategory.Politics]: 'Post-External-Event-Category-External-Event',
        [ExternalEventSeriesCategory.PublicHoliday]: 'Post-External-Event-Category-External-Event',
        [ExternalEventSeriesCategory.Social]: 'Post-External-Event-Category-External-Event',
        [ExternalEventSeriesCategory.Sport]: 'Post-External-Event-Category-External-Event',
        [ExternalEventSeriesCategory.Competition]: 'Post-External-Event-Category-Event',
        [ExternalEventSeriesCategory.World]: 'Post-External-Event-Category-Event',
        [ExternalEventSeriesCategory.ExternalConstruction]: 'Post-External-Event-Category-Project',
    },
};

export function mapToPhaseColor(
    phaseType: ExternalEventAllocationUsageType,
    category: ExternalEventSeriesCategory,
): PhaseColor;
export function mapToPhaseColor(phaseType: Exclude<PhaseTypeDatabase, ExternalEventAllocationUsageType>): PhaseColor;
export function mapToPhaseColor(phaseType: PhaseTypeDatabase, category?: ExternalEventSeriesCategory): PhaseColor {
    if (isExternalEventPhase(phaseType)) {
        return externalEventColorMap[phaseType][category!];
    }

    return nonExternalEventColorMap[phaseType];
}

function isExternalEventPhase(phaseType: PhaseTypeDatabase): phaseType is ExternalEventAllocationUsageType {
    return (
        phaseType === ExternalEventAllocationUsageType.PreExternalEvent ||
        phaseType === ExternalEventAllocationUsageType.ExternalEvent ||
        phaseType === ExternalEventAllocationUsageType.PostExternalEvent
    );
}
